export enum StatusApplicationKeys {
  APPROVED = 'approved',
  NO_PLACES_AVAILABLE = 'noPlacesAvailable',
  PENDING = 'pending',
  REGISTERED = 'registered',
  APPLICATIONS_CANCELED = 'applicationsCanceled',
  EVENT_CANCELED = 'eventCanceled',

  CANCELED = 'canceled',
}

// status_application_ref
export const StatusApplicationCode: Record<StatusApplicationKeys, number> = {
  [StatusApplicationKeys.APPROVED]: 1,
  [StatusApplicationKeys.NO_PLACES_AVAILABLE]: 2,
  [StatusApplicationKeys.PENDING]: 3,
  [StatusApplicationKeys.REGISTERED]: 4,
  [StatusApplicationKeys.APPLICATIONS_CANCELED]: 5,
  [StatusApplicationKeys.EVENT_CANCELED]: 6,

  [StatusApplicationKeys.CANCELED]: -1, // виртуальный статус только для фильтра
};

export const StatusApplicationCodeText: Record<number, string> = {
  [StatusApplicationCode.approved]: 'Заявка одобрена',
  [StatusApplicationCode.noPlacesAvailable]: 'Мест на выбранную дату нет',
  [StatusApplicationCode.pending]: 'Заявка на рассмотрении',
  [StatusApplicationCode.registered]: 'Ты зарегистрирован(а)',
  [StatusApplicationCode.applicationsCanceled]: 'Отмена заявки',
  [StatusApplicationCode.eventCanceled]: 'Отмена мероприятия',

  [StatusApplicationCode.canceled]: 'Отменено',
};
